<template>
  <b-container
    fluid
    class="cover-bg"
    :class="bg"
  >
    <div
      class="main-container cover-content content-padding-t-b-86"
    >
      <h1
        class="font-weight-bold f-s-54 l-h-65 l-s-175 p-b-7"
        :class="blackText ? 'b-text' : 'white'"
      >
        {{ title }}
      </h1>
      <p
        class="f-w-600 f-s-24 l-h-29 l-s-175"
        :class="blackText ? 'b-text' : 'white'"
      >
        {{ text }}
      </p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'CoverBg',
  props: {
    title: {
      type: String,
      default: '',
    },
    bg: {
      type: String,
      default: 'cover-bg-def',
    },
    text: {
      type: String,
      default: '',
    },
    blackText: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
